module.exports = __webpack_public_path__ + "fonts/CashSans-LightItl.2e21fda.woff2";